import { ItemView } from '@glu/core';
import template from './rowGroupHeader.hbs';

export default ItemView.extend({
  tagName: 'tr',
  className: 'grid-row-group-header',
  template,

  events: {
    'click @ui.$rowSelector': 'handleSelectRow'
  },

  ui: {
    $rowSelector: '.group-row-selector'
  },

  initialize() {
    this.groupId = this.model.cid;

    if (this.model.get('hasRowSelector')) {
      this.listenTo(this.appBus, `grid:selectRow:group:${this.groupId}`, this.unSelectCheckBox);
    }
  },

  templateHelpers() {
    return {
      groupTitle: this.model.getGroupTitle(),
      groupId: this.groupId
    };
  },

  handleSelectRow() {
    // Broadcast the row select event.
    this.appBus.trigger(`grid:selectAllRows:group:${this.groupId}`, this);

    // Trigger event that all group is selected
    this.appBus.trigger('grid:group:selectAllRows', this);
  },

  unSelectCheckBox() {
    const rowSelectorClass = `.row-selector-group-${this.groupId}`;

    // See how many rows are selected in the table.
    const allRowsSelected = this.$el.parents('table').find(`${rowSelectorClass}:not(:checked)`).size() === 0;

    // If all rows are selected, check the "select all group" box.
    if (allRowsSelected) {
      return;
    }
    this.ui.$rowSelector.prop('checked', false);
  }
});
